<div class="container mt-3" *ngIf="loadingIndicator; else main_content">
  <div class="product-box pt-2 pb-3">
    <div class="row">
      <div class="col-xs-12">
        <div class="wrapper pt-4 pb-4 text-center" [attr.data-qa]="'loadingIndicator-wrapper'">
          <span class="h2">Please Wait...<span class="fa fa-spinner fa-pulse fa-fw"></span></span>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #main_content>
  <div *ngIf="!externalAccountsByCategory">
    <div class="container mt-3" [attr.data-qa]="'external_accounts_container'">
      <div class="row mb-3">
        <div class="col-xs-12">
          <h2 class="h2 agg-main-title product-subtitle" [attr.data-qa]="'external_accounts_heading'">External Accounts</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-9">
          <p [attr.data-qa]="'external_accounts_p'">
            The following non-Prudential accounts have been added to your online profile.
          </p>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 mb-3 text-right manage-acc-btn">
          <span class="color-scheme-gray">
            <button *featureToggle="'aggEnabled'" [attr.data-qa]="'external_accounts_add_accounts_button'" type="button" class="btn btn-link p-0 add-accounts"
              (click)="openSpecifiedModal('finapp-tool-modal')" [autoFocus]="manageBtn === 'add'">Add Accounts
              <span class="sr-only">opens a modal dialog</span>
            </button>
          </span>
        </div>
      </div>
      <div class="col-xs-12 alert alert-warning alert-inline alert-dismissable" role="alert"
        [attr.data-qa]="'external_accounts_aggProfileErrorMessage'" *ngIf="aggProfileErrorMessage">
        <span class="sr-only">warning</span>
        <span class="h5 text-warning">{{aggProfileErrorMessage}}</span>
      </div>
      <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service - error">
        <div class="row">
          <div class="col-sm-12 hidden-xs">
            <div class="alert alert-danger alert-inline" role="alert" [attr.data-qa]="'external_accounts_warningMessage'">
              <span class="sr-only">warning</span>
                <error-msg lob="ExtAccounts" msgcode="missing"></error-msg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="externalAccountsByCategory && externalAccountsByCategory.length !== 0">
    <div class="container mt-3" [attr.data-qa]="'external_accounts_product_container'">
      <div class="row mb-3">
        <div class="col-xs-12">
          <h2 class="h2 agg-main-title product-subtitle" [attr.data-qa]="'external_accounts_product-subtitle'">External Accounts</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-9">
          <p [attr.data-qa]="'external_accounts_product_subtitle_para'">
            The following non-Prudential accounts have been added to your online profile.
          </p>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 mb-3 text-right manage-acc-btn">
          <span class="color-scheme-gray">
            <button *featureToggle="'aggEnabled'" type="button" class="btn btn-link p-0 add-accounts" [attr.data-qa]="'external_accounts_add_accounts_button2'"
              (click)="openSpecifiedModal('finapp-tool-modal')" [autoFocus]="manageBtn === 'add'">Add Accounts
              <span class="sr-only">opens a modal dialog</span>
            </button>
          </span>
        </div>
      </div>
      <div class="col-xs-12 alert alert-warning alert-inline alert-dismissable" role="alert"
        *ngIf="aggProfileErrorMessage" [attr.data-qa]="'external_accounts_alert_aggProfileErrorMessage'">
        <span class="sr-only">warning</span>
        <span class="h5 text-warning">{{aggProfileErrorMessage}}</span>
      </div>
    </div>
    <div class="container" *ngIf="externalAccountsByCategory.length != 0" [attr.data-qa]="'external_accounts_table_container'">
      <div class="product-box pb-3" role="grid">
        <div class="row hidden-xs hidden-sm" role="row">
          <div class="col-xs-12">
            <div class="col-xs-6 col-sm-6 col-md-4 pb-2" role="columnheader" [attr.data-qa]="'table_account_details_header'">
              <p class="text-column-header">
                Account Details
              </p>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-3 pb-2" role="columnheader" [attr.data-qa]="'table_type_header'">
              <p class="text-column-header">
                Type
              </p>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-3 pb-2" role="columnheader" [attr.data-qa]="'table_updated_on_header'">
              <p class="text-column-header">
                Updated On
              </p>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-2 pb-2" role="columnheader" [attr.data-qa]="'table_value_header'">
              <p class="text-column-header text-right">
                Value
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12" *ngFor="let title of prodTitles">
            <ng-container *ngIf="externalAccountsByCategory[title].length > 0">
              <div role="row" [attr.data-qa]="'table_agg_sum_details'">
                <div class="col-xs-4 account-section-header ribbon ribbon-{{ title }} pt-3 pb-2 mb-2" role="gridcell">
                  <h3 [attr.data-qa]="'table_agg_sum_title'" class="text-capitalize">{{ title }}</h3>
                </div>
                <div class="col-xs-8 account-section-header pt-3 pb-2 mb-2 text-right" role="gridcell"  [attr.data-qa]="'table_agg_sum_value'">
                  <span class="h3">
                    {{
                    externalAccountsByCategory[title]
                    | aggSum
                    | currency: 'USD':'symbol-narrow':'1.2-2'
                    }}
                  </span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 account-value pt-2 pb-2" role="row" *ngFor="
                  let contract of (externalAccountsByCategory[title] | orderBy: ['productTitle']);let idx = index;
                " [attr.data-qa]="'table_agg_sum_row'">
                <!-- <div class="pl-0 pr-0 col-xs-5 col-sm-5 hidden-md hidden-lg pl-0"></div> -->
                <div class="pl-0 pr-0 col-xs-12 col-sm-12 col-md-4 pl-0 text-truncate" role="gridcell" [attr.data-qa]="'table_agg_col1'">
                  <ng-container *featureToggle="'aggEnabled'">
                  <div class="p pl-0 col-xs-12 agg-value prod-title-hover agg-title special-bold">
                    <div class="reconn" [attr.data-qa]="'table_agg_reconnect'" *ngIf="contract.contractStatus && (contract.contractStatus === '0' || contract.contractStatus === '801' || contract.contractStatus === '802') && contract.providerAccountID; else btnDisabled"
                    (click)="openSpecifiedModal('finapp-tool-modal', contract.providerAccountID, contract.contractID)">
                    <div class="text-truncate" style="display:inline-block;max-width:95%;" [attr.data-qa]="'table_agg_enabled_prodTitle'">{{ contract.productTitle ? contract.productTitle : '' }}
                    <span *ngIf="contract.contractID && contract.contractID.indexOf('not available') <= 0" [attr.data-qa]="'table_agg_enabled_contractID'">
                      <span class="sr-only">Account Number: </span>#{{
                      contract.contractID ? contract.contractID : ''
                      }}</span>
                    </div>
                      <button type="button" class="btn btn-sm btn-link p-0 pl-2 mb-3" [attr.data-qa]="'table_agg_btn_finapp'" [autoFocus]="manageBtn === contract.providerAccountID+contract.contractID">
                        <span class="sr-only">edit {{contract.productTitle}} opens a modal dialog</span>
                        <span class="fa fa-lg fa-pencil">
                        </span>
                      </button>
                    </div>
                    <ng-template #btnDisabled>
                      <div class="p pl-0 col-xs-12 agg-value prod-title-hover agg-title special-bold text-truncate" [attr.data-qa]="'table_agg_col_contractId'">
                        {{ contract.productTitle ? contract.productTitle : '' }}
                        <span *ngIf="contract.contractID && contract.contractID.indexOf('not available') <= 0">
                          <span class="sr-only">Account Number: </span>#{{
                          contract.contractID ? contract.contractID : ''
                          }}</span>
                      </div>
                    </ng-template>
                  </div>
                  </ng-container>
                  <div *ngIf="!winRef.nativeWindow.aggEnabled" class="p pl-0 col-xs-12 agg-value prod-title-hover agg-title special-bold text-truncate" [attr.data-qa]="'table_agg_col_prod_title'">
                    {{ contract.productTitle ? contract.productTitle : '' }}
                    <span *ngIf="contract.contractID && contract.contractID.indexOf('not available') <= 0" [attr.data-qa]="'table_agg_col_contractId'">
                      <span class="sr-only">Account Number: </span>#{{
                      contract.contractID ? contract.contractID : ''
                      }}</span>
                    </div>
                </div>
                <div class="pl-0 pr-0 col-xs-5 col-sm-5 hidden-md hidden-lg" [attr.data-qa]="'table_agg_col_type'">
                  <p class="agg-value agg-title">
                    Type
                  </p>
                </div>
                <div class="pl-0 pr-0 col-xs-7 col-sm-7 col-md-3 xs-text-right text-truncate" role="gridcell"  [attr.data-qa]="'table_agg_col_producttype'">
                  <!--pipe name - camelCase-->
                  <p class="agg-value text-capitalize" *ngIf="contract.productType">
                    {{ contract.productType | camelCase }}
                  </p>
                </div>
                <div class="pl-0 pr-0 col-xs-5 col-sm-5 hidden-md hidden-lg" [attr.data-qa]="'table_agg_col_updatedon'">
                  <p class="agg-value agg-title">
                    Updated On
                  </p>
                </div>
                <div class="pl-0 pr-0 col-xs-7 col-sm-7 col-md-3 xs-text-right text-truncate" role="gridcell" [attr.data-qa]="'table_agg_col_date_div'">
                  <span class="p agg-value" [attr.data-qa]="'table_agg_col_as_of_date'"
                    *ngIf="contract.contractStatus && (contract.contractStatus === '0' || contract.contractStatus === '801' || contract.contractStatus === '802'); else finappReconnect">
                    <span *ngIf="contract.asOfDate">
                      As of {{ contract.asOfDate ? contract.asOfDate : '' }}
                    </span>
                  </span>
                  <ng-template #finappReconnect>
                    <span class="p agg-value">
                      <span class="text-danger" aria-hidden="true" *ngIf="contract.asOfDate" [attr.data-qa]="'table_agg_col_as_of_date'">
                        <span class="fa fa-exclamation-triangle" aria-hidden="true">
                        </span>
                        As of {{ contract.asOfDate }}
                      </span>
                      <span class="hidden-md hidden-lg"><br /></span>
                      <ng-container *featureToggle="'aggEnabled'">
                        <button type="button" [attr.data-qa]="'table_agg_reconnect'" class="btn btn-link reconnect-btn" *ngIf="contract.providerAccountID"
                          (click)="openSpecifiedModal('finapp-tool-modal', contract.providerAccountID, 0)">
                          Reconnect
                          <span class="sr-only">opens a modal dialog</span></button>
                      </ng-container>
                    </span>
                  </ng-template>
                </div>
                <div class="pl-0 pr-0 col-xs-12 col-sm-12 col-md-2 text-right pr-0 text-truncate" role="gridcell" [attr.data-qa]="'table_agg_col_acc_value'">
                  <p class="agg-value value-subtitle special-bold">
                    {{
                    convertNum(
                    contract.primaryContractValue.value
                    ? contract.primaryContractValue.value
                    : ''
                    ) | currency: 'USD':'symbol-narrow':'1.2-2'
                    }}
                  </p>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<pru-finapp-tool-modal *ngIf="!logOutFailed" [modalId]="finAppToolModalId" [finAppName]="'FastLink'"
  (closeModalEmitterFinApp)="closeSpecifiedModal(finAppToolModalId, $event)" #finAppToolModal></pru-finapp-tool-modal>
